// extracted by mini-css-extract-plugin
export default {"top-space":"ChooseAnotherDate_top-space__36RCe","extra-space":"ChooseAnotherDate_extra-space__yeRil"};